import Vue from 'vue';
import Router from 'vue-router';
import store from '../store/store';
import { Role, PortalClienteResource } from '../resources/role';
import defineAbilitiesFor from '../resources/ability';

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '*',
      component: () => import('../components/portal-cliente/errors/404.vue')
    },
    {
      path: '/',
      name: 'root',
      component: () => import('../components/portal-cliente/ComponentRoot.vue'),
      meta: Role.acceso
    },
    {
      path: '/dashboard/:tab/:subTab?',
      name: 'dashboard',
      component: () => import('../components/portal-cliente/AltaImpago.vue'),
      meta: Role.acceso
    },
    {
      path: '/drafts/:claimType/:step/:draftId?',
      name: 'draft',
      component: () => import('../components/portal-cliente/RegistrarImpagoContainer.vue'),
      meta: Role.acceso
    },
    {
      path: '/drafts/:claimType/:step/:draftId/bonoUsado/:bonoUsado?',
      name: 'debt',
      component: () => import('../components/portal-cliente/RegistrarImpagoContainer.vue'),
      meta: Role.acceso
    },
    {
      path: '/consultaRealizada/:tokenSolicitud',
      name: 'consultaRealizada',
      component: () => import('../components/portal-cliente/ConsultaFichero/ConsultaRealizada.vue'),
      meta: Role.consultaFichero
    },
    {
      path: '/formularioDatosPropios',
      name: 'formularioDatosPropios',
      component: () => import('../components/portal-cliente/ConsultaFichero/FormularioDatosPropios.vue'),
      meta: Role.consultaFichero
    },
    {
      path: '/consultaFichero/:codType?/:draftId?',
      name: 'consultaFichero',
      component: () => import('../components/portal-cliente/ConsultaFichero/ConsultaFichero.vue'),
      meta: Role.consultaFichero
    },
    {
      path: '/paymentDeclined',
      name: 'paymentDeclined',
      component: () => import('../components/portal-cliente/RespuestasPagos/altaImpagoRechazada.vue'),
      meta: Role.acceso
    },
    {
      path: '/claims/:token',
      name: 'claim',
      component: () => import('../components/portal-cliente/Expedientes/Reclamacion.vue'),
      meta: Role.acceso
    },
    {
      path: '/claims/:token/:altaOK',
      name: 'claimFromAlta',
      component: () => import('../components/portal-cliente/Expedientes/Reclamacion.vue'),
      meta: Role.acceso
    },
    {
      path: '/altaImpagoCancelada',
      name: 'altaImpagoCancelada',
      component: () => import('../components/portal-cliente/RespuestasPagos/altaImpagoCancelada.vue'),
      meta: Role.acceso
    },
    {
      path: '/settings/accountAndBilling',
      name: 'accountAndBilling',
      component: () => import('../components/portal-cliente/Configuracion/CuentaYFacturacion/CuentaYFacturacion.vue'),
      meta: Role.miCuenta,
      children: [
        {
          path: '',
          redirect: 'billing'
        },
        {
          path: 'billing',
          name: 'billing',
          component: () => import('../components/portal-cliente/Configuracion/CuentaYFacturacion/DatosFacturacion/DatosFacturacion.vue'),
          meta: Role.miCuenta
        },
        {
          path: 'contact',
          name: 'contact',
          component: () => import('../components/portal-cliente/Configuracion/CuentaYFacturacion/DatosContacto/DatosContacto.vue'),
          meta: Role.miCuenta
        },
        {
          path: 'usage',
          name: 'usage',
          component: () => import('../components/portal-cliente/Configuracion/CuentaYFacturacion/UsosConsumo/UsosConsumo.vue'),
          meta: Role.miCuenta
        },
      ]
    },
    {
      path: '/settings/profile',
      name: 'profile',
      component: () => import('../components/portal-cliente/Configuracion/Profile/MiCuenta.vue'),
      meta: Role.miCuenta
    },
    {
      path: '/settings/profile#myInvoices',
      name: 'myInvoices',
      component: () => import('../components/portal-cliente/Configuracion/Profile/MiCuenta.vue'),
      meta: Role.miCuenta
    },
    {
      path: '/errors/403',
      name: 'http403',
      component: () => import('../components/portal-cliente/errors/403.vue')
    },
    {
      path: '/errors/404',
      name: 'http404',
      component: () => import('../components/portal-cliente/errors/404.vue')
    },
    // Portal Gran Cliente
    {
      path: '/portal',
      name: 'portal',
      component: () => import('../components/portal-gran-cliente/AppGrandesCuentas.vue'),
      meta: Role.acceso
    },
    {
      path: '/portal/expedientes',
      name: 'portal-expedientes',
      component: () => import('../components/portal-gran-cliente/Expedientes/listadoExpedientes.vue'),
      meta: Role.acceso
    },
    {
      path: '/portal/consultas',
      name: 'grandes-cuentas_consultas',
      component: () => import('../components/portal-gran-cliente/consultas/ListadoConsultas.vue'),
      meta: Role.acceso
    },
    {
      path: '/portal/consultas/:token/:deudas?',
      name: 'grandes-cuentas_consultas-detalle',
      component: () => import('../components/portal-gran-cliente/consultas/DetalleConsulta.vue'),
      meta: Role.acceso
    },
    {
      path: '/portal/expedientes/:uuid/edit',
      name: 'expedient',
      component: () => import('../components/portal-gran-cliente/Expedientes/DetalleExpediente.vue'),
      meta: Role.acceso
    },
    {
      path: '/portal/expedientes/new',
      name: 'nuevoExpediente',
      component: () => import('../components/portal-gran-cliente/altaOperacion/AltaOperacion.vue'),
      meta: Role.acceso
    },
    {
      path: '/portal/misCarteras',
      name: 'misCarteras',
      component: () => import('../components/portal-gran-cliente/Carteras/MisCarteras.vue'),
      meta: Role.acceso
    }
  ],

  mode: 'history',
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

router.beforeResolve((to, from, next) => {
  if (to.path === '/users/auth/redabogaciaopenid') {
    return next({ name: 'root' });
  }
  if (to.name == 'draft') {
    if (to.query.orderID != undefined) {
      return next({
        name: 'draft',
        query: {},
        params: to.params,
        replace: true
      })
    }
  }

  const currentProfile = store.state.profile
  const abilities = defineAbilitiesFor(currentProfile)
  const canNavigate = to.matched.some(route => {
    const action = route.meta.action
    if (action) {
      let permitido = abilities.can(route.meta.action, PortalClienteResource)
      return permitido;
    } else {
      next()
    }
  })
  if (!canNavigate) {
    return next('/errors/403')
  }
  next()
})

export default router;
